import { useMutationHook, useQueryHook } from "@/hooks"
import { readDeliveryInfo, readDeliveryList, receiveDelivery } from "@/app/api/delivery"
import { UseQueryOptions } from "@tanstack/react-query"
import { DeliveryDetail } from "@/types/delivery"
import { ApiError } from "@/app/api/type"

export const useDeliveryListQuery = () => {
  return useQueryHook({
    queryKey: ["readDeliveryList"],
    queryFn: async () => await readDeliveryList(),
  })
}

export const useDeliveryInfoQuery = (idfTransfer: number, enabled?: boolean) => {
  return useQueryHook({
    queryKey: ["readDeliveryInfo", idfTransfer],
    queryFn: async () => await readDeliveryInfo(idfTransfer),
    options: {
      enabled,
    } as UseQueryOptions<DeliveryDetail, ApiError>,
  })
}

export const useReceiveDeliveryMutation = (idfTransfer: number) => {
  return useMutationHook(
    (params: { idfTransfer: number; deviceTypes: string[] }) => receiveDelivery(params),
    [["readDeliveryList"], ["readDeliveryInfo", idfTransfer]],
  )
}
